/* eslint-disable no-console */

import {register} from 'register-service-worker'

export function install(){
  if (typeof window.isSecureContext === 'boolean' && window.isSecureContext) {
    register(`${process.env.BASE_URL}service-worker.js`, {
      // registrationOptions:
      ready () {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload()
        })
      },
      registered () {
        console.log('Service worker has been registered.')
      },
      cached () {
        console.log('Content has been cached for offline use.');
      },
      updatefound () {
        console.log('New content is downloading.')
        // Proactively queue skipWaiting so the update doesn't sit "waiting" for a manual refresh.
        // requestSkipWaiting(registration)
      },
      updated () {
        console.log('New content is available; activating update...')
        // window.location.reload(); // future
        // requestSkipWaiting(registration)
      },
      offline () {
        console.log('No internet connection found. App is running in offline mode.')
      },
      error (error) {
        console.error('Error during service worker registration:', error);
        // if there is code, that could f*** the serviceworker, add this unregister() call.
        // unregister();
      }
    })
  }
}

export function forceKillCache(){
  caches.keys().then(function(cacheNames){cacheNames.forEach(function(cacheName){caches.delete(cacheName).then();});});
}
